import './checkbox.css';

/**
 * Чекбокс. С `label` рендерит обёртку `<label>` с подписью, без него — голый
 * `<input type="checkbox">`. Стили — в `checkbox.css` на токенах `--theme-*`
 * (раньше были Tailwind-утилиты плюс inline `accentColor`).
 */
const Checkbox = ({ className = '', checked, onCheckedChange, id, label, ...props }) => {
  const input = (
    <input
      id={id}
      type="checkbox"
      className={`checkbox ${className}`.trim()}
      checked={checked}
      onChange={(e) => onCheckedChange && onCheckedChange(e.target.checked)}
      {...props}
    />
  );

  if (!label) return input;

  return (
    <label htmlFor={id} className="checkbox__wrapper">
      {input}
      <span className="checkbox__label">{label}</span>
    </label>
  );
};

export { Checkbox };
